import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import { Component, Host, h, Prop } from '@stencil/core';
import { ExternalArticleSlideData } from './external-article-slide.types';
import type { EfbButton } from '../../atoms/button/button';

/**
 * External article.
 */
@Component({
  tag: 'efb-external-article-slide',
  styleUrl: 'external-article-slide.scss',
  shadow: true,
})
export class EfbExternalArticleSlide {
  /**
   * Img.
   */
  @Prop() img: ExternalArticleSlideData['img'] | string;

  @Memoize('img')
  get parsedImg(): ExternalArticleSlideData['img'] {
    return parseIfString(this.img);
  }

  /**
   * Heading
   */
  @Prop() heading: ExternalArticleSlideData['heading'];

  /**
   * text
   */
  @Prop() text: ExternalArticleSlideData['text'];

  /**
   * button
   */
  @Prop() button: EfbButton | string;

  @Memoize('button')
  get parsedButton(): EfbButton {
    return parseIfString(this.button);
  }

  /**
   * Modal article target id
   */
  @Prop() modalTarget: string;

  render() {
    const { parsedImg: img, heading, text } = this;

    return (
      <Host>
        <efb-click-action
          tagClass="external-article-slide"
          name="open-article-modal"
          value={this.modalTarget}
          dataAnalytics={this.parsedButton?.dataAnalytics}
        >
          <div class="head">
            <efb-img class="head-img" cover {...img} />
          </div>
          <div class="body">
            <div class="title">{heading}</div>
            <div class="text">{text}</div>
            <div class="buttons">
              <efb-button text={this.parsedButton.text} variant="purple" small ghost />
            </div>
          </div>
        </efb-click-action>
      </Host>
    );
  }
}
